import React from "react";
import { ContentViolationFlagType } from "@teachers/easel-global-utils/dist/contentTakedown";
import styled from "@emotion/styled";
import { designTokens } from "../../helpers/constants";
import Text from "../global/Text";

export interface ContentViolationScreenProps {
  contactUsHref?: string;
  copyrightPolicyHref?: string;
  inappropriateContentPolicyHref?: string;
  flagType: ContentViolationFlagType;
  isSellerContent?: boolean;
}

const Body: React.FC<ContentViolationScreenProps> = ({
  isSellerContent,
  flagType,
  contactUsHref,
  copyrightPolicyHref,
  inappropriateContentPolicyHref,
}) => {
  if (isSellerContent && flagType === ContentViolationFlagType.IC) {
    return (
      <Text variant="body" align="center">
        This resource has been deactivated in accordance with our{" "}
        <Link href={inappropriateContentPolicyHref}>
          Inappropriate Content Policy.
        </Link>
        <br />
        If you have any questions, please{" "}
        <Link href={contactUsHref}>Contact Us</Link>
      </Text>
    );
  }

  if (isSellerContent && flagType === ContentViolationFlagType.IP) {
    return (
      <Text variant="body" align="center">
        This product has been deactivated in accordance with our{" "}
        <Link href={copyrightPolicyHref}>Copyright Policy</Link>
        . You have the
        <br />
        right to file a counter-notification. Please review the{" "}
        <Link href={copyrightPolicyHref}>Copyright Policy</Link>
        &nbsp;for instructions
      </Text>
    );
  }

  return (
    <Text variant="body" align="center">
      This resource has been removed from the site.
      <br />
      You can still review student work but students can no longer access the
      content.
      <br />
      We apologize for any inconvenience. If you have any questions, please{" "}
      <Link href={contactUsHref}>Contact Us</Link>
    </Text>
  );
};

export const ContentViolationScreen: React.FC<ContentViolationScreenProps> = (
  props
) => (
  <Container>
    <Body {...props} />
  </Container>
);

const Link = styled.a({
  color: "inherit",
  fontSize: "inherit",
  textDecoration: "underline",
  fontWeight: 400,
  "&:visited": {
    color: "inherit",
  },
});

const Container = styled.div({
  display: "flex",
  height: "100vh",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: designTokens["ds-color-gray-200"],
});
